export default __webpack_public_path__ + "static/media/video_s.9f286ae5.png";